import SyncLog from './SyncLog';

export default SyncLog;
